import React from 'react';
import s from "./hero.module.css";
import { withPrefix } from 'gatsby';

const Hero = (props) => (
  <header className={`pb-4 pb-@md5 ${s.hero}`}>
    <img alt='' src={withPrefix(props.image?'/images/'+props.image:'/images/banner-004.jpg')} className={s.heroImage}/>
    <div className='container'>
      <div className={`w-60@md c-white ${s.content}`}>
        <h1 className='f-3 f-5@md mb-3'>{props.title}</h1>
        {props.description ?
          <p>{props.description}</p>
          : null
        }
      </div>
    </div>
  </header>
)

export default Hero
